import {WindowType, Master} from '@/hosted_fields/common/enums';
import Client, {MASTER_IFRAME_NAME} from '@/hosted_fields/common/connection/client';
import Receiver from '@/hosted_fields/common/connection/receiver';
import ChildActions from '@/hosted_fields/component/child-actions';
import '@/helpers/polyfills';
import {setLocaleText} from '@/hosted_fields/common/locale';

new Receiver(WindowType.Component);
const client = new Client(WindowType.Component, true);
ChildActions(client);

// Load Preset translations during component initialization (js domain)
function loadTranslations() {
  const message = {
    action: Master.Actions.GetTranslations,
  };
  client.sendMessage(message, MASTER_IFRAME_NAME).then((translations: any) => {
    setLocaleText(translations);
  });
}

(function initialize() {
  loadTranslations();
})();

const htmlElement = document.getElementsByTagName('html')[0];
htmlElement.addEventListener('keyup', (e) => {
  if (e.key === 'Tab') {
    if (e.target === document.getElementsByTagName('html')[0]) {
      if (!e.shiftKey) {
        const inputElements = document.getElementsByTagName('input');
        if (inputElements.length) {
          inputElements[0].focus();
        }
      } else {
        // TODO: Handle shift tab, to assign focus to previous focussable element
      }
    }
  }
});
